import React from 'react';
import { Image } from 'semantic-ui-react';
import Assets from 'mpm-assets';

export default (props) => {

    return (
        <div className='mpm-loader cusloading error'>
            <div className="mpm-loader-img">
                <Image src={Assets.Images.logo_mpm_big} as='img' size='medium' />
            </div>
            <div className="mpm-loader-txt">
                Conexion au serveur échoué
                </div>
            <div className="mpm-loader-txt">
                Veuillez actualiser la page d'authentification !!
                </div>
        </div>
    )
}